import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ce67c53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "package-page" }
const _hoisted_2 = { class: "ws_common_operation" }
const _hoisted_3 = { class: "table" }

import { onMounted, ref, watch, onUnmounted } from 'vue'
import { PAGE_SIZES, CODE_ENUM,PACKAGE_TYPE_ENUM } from '@/common'
import PackageForm from './components/package-form-step1.vue'
import { queryPackagePage, packageInfoPublish, packageDelete } from '@/api'
import { ElMessage } from 'element-plus'
import OperationButtonList from '@/components/operation-button-list'
import { msgbox } from '@/utils'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const router = useRouter()

const tableData: any = ref([])

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const buttonList = ref([
  {
    type: 'detail',
    text: '查看',
  },
  {
    type: 'edit',
    text: '编辑',
  },
  {
    type: 'delete',
    text: '删除',
  },
  {
    type: 'revoke',
    text: '撤销发布',
  },
  {
    type: 'release',
    text: '发布',
  },
])

const getButtonList = (scope: any) => {
  const { packageStatus } = scope.row

  const filterType = packageStatus ? 'release' : 'revoke'
  // 已发布 禁用删除和编辑
  const publishDisabledType = ['edit', 'delete']
  return buttonList.value.reduce((mo: any, el: any) => {
    if (filterType !== el.type) {
      const disabled = packageStatus && publishDisabledType.includes(el.type)
      mo.push({
        ...el,
        disabled,
      })
    }
    return mo
  }, [])
}

const col: any = [
  {
    prop: 'packageName',
    label: '套餐名称',
    formatter: ({ packageUserTypeValue, packageName }: any) => {
      return packageUserTypeValue + '-' + packageName
    },
  },
  {
    prop: 'chargeMode',
    label: '计费模式',
  },
  {
    prop: 'chargModePeriod',
    label: '生效周期',
  },
  {
    prop: 'shortMsgTotal',
    label: '卫星短报文数量（条/天）',
  },
  {
    prop: 'price',
    label: '套餐价格(元)',
  },
]

const tableLoading = ref(false)
const fetchList = async () => {
  tableLoading.value = true
  const res: any = await queryPackagePage({
    ...pageParams.value,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

fetchList()

const packageConf: any = ref({
  visible: false,
  data: {},
})

const publishPackage = async ({ id, packageStatus }: any) => {
  const res: any = await packageInfoPublish({
    id,
    packageStatus: !packageStatus,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success('操作成功')
  }

  fetchList()
}
const toDelete = ({ id }: any) => {
  msgbox({
    tip: '你确定要删除这个套餐吗？',
    thenFn: () => handleDelete({ id }),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await packageDelete({
    id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success('操作成功')
  }

  fetchList()
}

const handleCommand = (command:any)=>{
  toPackageForm({
    packageUserTypeCode:command
  })
}

const toPackageForm = (data = {}) => {
  packageConf.value = {
    visible: true,
    data,
  }
}

const toDetail = ({ id }: any) => {
  router.push({
    name: 'package-detail',
    query: { id },
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  command: _unref(PACKAGE_TYPE_ENUM).PACKAGE_COMPANY
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("企业套餐")
                  ]),
                  _: 1
                }, 8, ["command"]),
                _createVNode(_component_el_dropdown_item, {
                  command: _unref(PACKAGE_TYPE_ENUM).PACKAGE_PRIVATE
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("个人套餐")
                  ]),
                  _: 1
                }, 8, ["command"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("添加套餐")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "ws_common_table ws_mt20",
          data: tableData.value
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
              return _createVNode(_component_el_table_column, {
                key: index,
                prop: item.prop,
                label: item.label,
                formatter: item.formatter,
                "show-overflow-tooltip": ""
              }, null, 8, ["prop", "label", "formatter"])
            }), 64)),
            _createVNode(_component_el_table_column, {
              prop: "packageStatus",
              label: "套餐状态"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  type: scope.row.packageStatus ? 'success' : 'warning'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.packageStatus ? '已发布' : '未发布'), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              width: 460,
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_unref(OperationButtonList), {
                  buttonList: getButtonList(scope),
                  scope: scope.row,
                  onOnDetail: toDetail,
                  onOnEdit: toPackageForm,
                  onOnDelete: toDelete,
                  onOnRelease: publishPackage,
                  onOnRevoke: publishPackage
                }, null, 8, ["buttonList", "scope"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(PackageForm, {
      visible: packageConf.value.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((packageConf.value.visible) = $event)),
      data: packageConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})